import $ from 'jquery';
import "./_jquery-ui.js";

export default function (params) {

let $this,
	config = {
		selectBlock: '',
		inputId: ''
	},
	$viewDate,
	$iconDate,
	$calendar,
	$inputId,
	monthNamesShort= [ "Янв","Фев","Мар","Апр","Май","Июн",
	"Июл","Авг","Сен","Окт","Ноя","Дек" ],
	$document = $(document);

/**
 * metod Init
 */
function init() {
	$this = $(config.selectBlock);
	$viewDate = $('.js_view-date', $this);
	$iconDate = $('.js_view-icon', $this);
	$calendar = $('.js_view-datepicker', $this);
	$inputId =  $(config.inputId, $this);

	local();
	initDataPicker();
	subscription();
	
	initDate();
}
/**
 * init start date
 * 21.04.2017
 */
function initDate() {
	let currentDate = getData();

	if (!currentDate) {
		 let now = new Date(),
		 	d = now.getDate(),
			m = now.getMonth() + 1,
			y = now.getFullYear();

		if (d < 10) d = '0'+d;
		if (m < 10) m = '0'+m;

		
		currentDate = y + '/' + m + '/' + d;
	}

	onChangeDate(currentDate);
}
/**
 * init dataPicker
 */
function initDataPicker() {
	$calendar.datepicker({
		minDate: 0,
		onSelect: function(currentDate){

			onChangeDate(transferDate(currentDate));
			hidden();
		}});
}
/**
 * event
 */
function subscription(){
	$viewDate.on('click', openClose);
	$iconDate.on('click', openClose);

	$inputId.on('Change', function(){
	})
}
/**
 * metod subscription click - document
 */
function clickGlobal() {
	setTimeout(function() {

		$document.on('click', testClickClobal);

	}, 30);	
}
function testClickClobal(ev) {	
	if (!$(ev.target).closest('.ui-datepicker-header, .ui-datepicker-calendar, .js_view-datepicker').length == 1) {
		hidden();
	}
}
function unClickGlobal() {
	$document.off('click', testClickClobal);
}
/**
 * Metod openClose calendar
 */
function openClose() {
	if ($calendar.hasClass('_visible')) {
		hidden();
	}  else {
		show();		
	}
}
/**
 * metod hidden
 */
function hidden() {
	$calendar.removeClass('_visible');
	unClickGlobal();
}
/**
 * metod show calendar
 */
function show() {
	$calendar.datepicker("setDate", getData());
	$calendar.addClass('_visible');
	clickGlobal();
}
/**
 * metod getData
 */
function getData() {
	let currentDate = $inputId.val();

	return currentDate && new Date(currentDate);
}
/**
 * metod Change Data
 */
function onChangeDate(currentDate) {
	$inputId.val(currentDate);

	renderDate();
}
/**
 * metod Transfer Date Format
 * 21.04.2017 -> 2017/04/21
 */
function transferDate(currentDate) {
	let m = currentDate.split('.');
	return m[2] + '/' + m[1] + '/' + m[0];
}
/**
 * metod Render
 */
function renderDate(){
	let m = $inputId.val().split('/'),
		month = parseInt(m[1], 10) - 1;

	$viewDate.html(''+
		'<span class="c-date-item__title">' + m[2] + ' ' 
		+ monthNamesShort[month] + '</span>'+
		'<span class="c-date-item__short">- ' + m[0] + '</span>')
}











function local() {

	let loc = {
	closeText: "Закрыть",
	prevText: "&#x3C;Пред",
	nextText: "След&#x3E;",
	currentText: "Сегодня",
	monthNames: [ "Январь","Февраль","Март","Апрель","Май","Июнь",
	"Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь" ],
	monthNamesShort: monthNamesShort,
	dayNames: [ "воскресенье","понедельник","вторник","среда","четверг","пятница","суббота" ],
	dayNamesShort: [ "вск","пнд","втр","срд","чтв","птн","сбт" ],
	dayNamesMin: [ "Вс","Пн","Вт","Ср","Чт","Пт","Сб" ],
	weekHeader: "Нед",
	dateFormat: "dd.mm.yy",
	firstDay: 1,
	isRTL: false,
	showMonthAfterYear: false,
	yearSuffix: "" };

$.datepicker.setDefaults(loc);
	
	



}



	
	$.extend(true, config, params||{});
	init();

	
}


// WEBPACK FOOTER //
// ./widget/select-date.js